"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _registerService = _interopRequireDefault(require("crm_data/flux/registerService"));

var _DealBoardSearchActionTypes = require("../board/deals/DealBoardSearchActionTypes");

var _TicketBoardSearchActionTypes = require("../board/tickets/TicketBoardSearchActionTypes");

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _ElasticSearchActions = _interopRequireDefault(require("crm_ui/flux/elasticSearch/ElasticSearchActions"));

var _DealBoardSearchActions = _interopRequireDefault(require("../board/deals/DealBoardSearchActions"));

var _TicketBoardSearchActions = _interopRequireDefault(require("../board/tickets/TicketBoardSearchActions"));

var _handlers;

var getMoveHandler = function getMoveHandler(eventName) {
  return function (state, actionOptions) {
    var _actionOptions = actionOptions,
        id = _actionOptions.id;
    actionOptions = (0, _immutable.Map)(actionOptions);

    if (state.hasIn(["" + id, eventName])) {
      var originalStage = state.getIn(["" + id, eventName, 'from']);
      actionOptions = actionOptions.set('from', originalStage);
    }

    return state.setIn(["" + id, eventName], actionOptions);
  };
};

var getMoveSavedHandler = function getMoveSavedHandler(eventName) {
  return function (state, _ref) {
    var id = _ref.id;
    return state.deleteIn(["" + id, eventName]);
  };
};

var getMoveRevertedHandler = function getMoveRevertedHandler(eventName, handleMove) {
  return function (state, id) {
    var lastUpdate = state.get("" + id);

    if (!lastUpdate) {
      return state;
    }

    var esAction = lastUpdate.get(_ActionTypes.ES_RESULT_MOVED);
    var cardAction = lastUpdate.get(eventName);

    _ElasticSearchActions.default.moveResult(esAction.objectType, esAction.toSearchQuery, esAction.fromSearchQuery, esAction.toViewId, esAction.fromViewId, esAction.id, esAction.toIndex);

    if (cardAction.get('to') === cardAction.get('from')) {
      return state;
    }

    handleMove.moveResult(cardAction.get('key'), cardAction.get('searchQuery'), cardAction.get('to'), cardAction.get('from'), cardAction.get('id'), cardAction.get('toIndex'));
    return state;
  };
};

var handlers = (_handlers = {}, (0, _defineProperty2.default)(_handlers, _DealBoardSearchActionTypes.MOVED, getMoveHandler(_DealBoardSearchActionTypes.MOVED)), (0, _defineProperty2.default)(_handlers, _TicketBoardSearchActionTypes.MOVED, getMoveHandler(_TicketBoardSearchActionTypes.MOVED)), (0, _defineProperty2.default)(_handlers, _ActionTypes.ES_RESULT_MOVED, function (state, actionOptions) {
  var id = actionOptions.id,
      objectType = actionOptions.objectType;

  if (objectType !== _ObjectTypes.DEAL && objectType !== _ObjectTypes.TICKET) {
    return state;
  }

  return state.setIn(["" + id, _ActionTypes.ES_RESULT_MOVED], actionOptions);
}), (0, _defineProperty2.default)(_handlers, _ActionTypes.DEALS_UPDATE_SUCCEEDED, getMoveSavedHandler(_DealBoardSearchActionTypes.MOVED)), (0, _defineProperty2.default)(_handlers, _ActionTypes.TICKETS_UPDATE_SUCCEEDED, getMoveSavedHandler(_TicketBoardSearchActionTypes.MOVED)), (0, _defineProperty2.default)(_handlers, _ActionTypes.REVERT_DEAL_STAGE_MOVE, getMoveRevertedHandler(_DealBoardSearchActionTypes.MOVED, _DealBoardSearchActions.default)), (0, _defineProperty2.default)(_handlers, _ActionTypes.TICKET_STAGE_CHANGE_REVERT, getMoveRevertedHandler(_TicketBoardSearchActionTypes.MOVED, _TicketBoardSearchActions.default)), _handlers);
(0, _registerService.default)((0, _immutable.Map)(), handlers);